/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parental_Controls_Quick_Action_TitleInputs */

const de_parental_controls_quick_action_title = /** @type {(inputs: Parental_Controls_Quick_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugendschutz-PIN`)
};

/** @type {(inputs: Parental_Controls_Quick_Action_TitleInputs) => LocalizedString} */
const en_parental_controls_quick_action_title = de_parental_controls_quick_action_title;

/**

* @param {Parental_Controls_Quick_Action_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const parental_controls_quick_action_title = /** @type {((inputs?: Parental_Controls_Quick_Action_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parental_Controls_Quick_Action_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_parental_controls_quick_action_title(inputs)
	return en_parental_controls_quick_action_title(inputs)
});